import { render } from "./GullyOnlineBookingHistory.vue?vue&type=template&id=a36e53d2&scoped=true"
import script from "./GullyOnlineBookingHistory.vue?vue&type=script&lang=js"
export * from "./GullyOnlineBookingHistory.vue?vue&type=script&lang=js"

import "./GullyOnlineBookingHistory.vue?vue&type=style&index=0&id=a36e53d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a36e53d2"]])

export default __exports__